<button mat-mini-fab class="mat-mini-fab-map-control" (click)="goFullScreen()" [matTooltip]="'map.control_fullscreen.tooltip' | translate"
  matTooltipPosition="left" matTooltipShowDelay="1000">
  <mat-icon>fullscreen</mat-icon>
</button>
